module.exports = __webpack_public_path__ + "img/youtube.9fb71495.png";